<template>
  <div class="level">
    <svgicon
      name="filter"
      width="30"
      height="30"
      color="#63CCCA"
      :original="true"
      class="level-item filter-icon"
      :class="{ notselected: filterTags.length === 0 }">
    </svgicon>
    <div class="level-item">
      <drop-down-auto-complete
        title="Labels"
        label="Filter by Label"
        :options="labelOptions"
        v-on:dropdown-selection="addLabelFilter($event.input)">
      </drop-down-auto-complete>
      <drop-down-auto-complete
        title="Versions"
        label="Filter by Version"
        :options="versionOptions"
        v-on:dropdown-selection="addVersionFilter($event.input)">
      </drop-down-auto-complete>
      <drop-down-auto-complete
        title="Tags"
        label="Filter by Tag"
        :options="tagOptions"
        v-on:dropdown-selection="addTagFilter($event.input)">
      </drop-down-auto-complete>
    </div>
    <div class="tags level-item filter-tags">
      <span
        v-for="filter in filterTags"
        :key="filter"
        class="tag is-rounded">
        <span>{{ filter }}</span>
        <a @click="removeFilterTag(filter)" role="button" tabindex="0" class="delete is-small"></a>
      </span>
    </div>
  </div>
</template>

<script>
import DropDownAutoComplete from '@/components/DropDownAutoComplete.vue';

export default {
  name: 'AssetsFilterBar',
  components: { DropDownAutoComplete },
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    this.labelOptions = await this.refreshOptions('label');
    this.tagOptions = await this.refreshOptions('tags');
    this.versionOptions = await this.refreshOptions('version');
  },
  data() {
    return {
      filterTags: [],
      labelOptions: [],
      tagOptions: [],
      versionOptions: [],
    };
  },
  watch: {
    internalFilter() {
      this.$emit('update:filter', this.internalFilter);
    },
  },
  computed: {
    internalFilter() {
      const filter = {
        filters: [],
        operator: 'and',
      };
      this.filterTags.forEach((f) => {
        const filterItem = f.split(':');
        if (filterItem[0] === 'tag') {
          filter.filters.push({
            tags: {
              any: [filterItem[1]],
              operator: 'and',
            },
          });
        } else if (filterItem[0] === 'version') {
          filter.filters.push({
            version: {
              eq: filterItem[1],
              operator: 'and',
            },
          });
        } else if (filterItem[0] === 'label') {
          filter.filters.push({
            label: {
              eq: filterItem[1],
              operator: 'and',
            },
          });
        }
      });
      if (Object.keys(filter.filters).length > 0) {
        return filter;
      }
      return filter;
    },
  },
  methods: {
    addLabelFilter(label) {
      this.filterTags.push(`label:${label}`);
    },
    addVersionFilter(version) {
      this.filterTags.push(`version:${version}`);
    },
    addTagFilter(tag) {
      this.filterTags.push(`tag:${tag}`);
    },
    removeFilterTag(tag) {
      this.filterTags = this.filterTags.filter(t => t !== tag);
    },
    async refreshOptions(field) {
      const labels = await this.$store.dispatch('primary/listAssetsStats', {
        field,
      });
      if (labels) {
        return labels;
      }
      return [];
    },

  },
};
</script>

<style lang="scss" scoped>

.filter-tags {
  .tag {
    color: $main-background;
    background-color: $expression-background;
  }
}

.level-left .level-item:not(:last-child) {
  &.filter-icon {
    margin-right: 0;
    margin-left: 1rem;
  }
}
</style>
